import cancel_icon from '~/public/images/cancel-icon.inline.svg';
import amaaya from '~/public/images/amaaya.inline.svg';
import reward from "~/public/images/reward.png";

const AmayaModalContent = ({ classes, styles, handleClose }) => {
    return (
        <>
            <a className={classes.close} onClick={handleClose}>
                <img src={cancel_icon} loading="lazy" width={22} height={22} />
            </a>
            <span className={styles.product_amaaya}>
                <img src={reward?.src} alt="amaaya icon" width={28} height={28} loading='lazy' />
            </span>
            <h3>1.What is Kama Ayurveda Loyalty Program?</h3>
            <p>
                The Kama Ayurveda Loyalty Program is our way of rewarding you! Every purchase brings 
                you closer to unlocking exclusive rewards, personalised experiences, and sacred Ayurvedic 
                secrets—an invitation to immerse yourself in the true essence of luxury and self-care. 
            </p>

            <h3>2. Who is eligible to join the program? </h3>
            <p>
                Your first purchase unlocks your gateway to the exclusive Kama Ayurveda Loyalty 
                Membership.
            </p>

            <h3>3. What are the benefits of this membership? </h3>
            <p>
            The more you shop, the more rewards you unlock! Enjoy 500 loyalty points instantly on your 
            first purchase*. As a member, you get tier-based benefits, exclusive gifts, priority service, and 
            a luxurious journey with every purchase you make. 
            </p>

            <h3>4. What is the value of a point?</h3>
            <p>1 Point is equivalent to 1 Rupee.</p>
        </>
    )
}

export default AmayaModalContent